import {mapState} from 'vuex'
import {formatUnit as formatUnitFromUtils, getPERatio} from '@/utils'
import {getStockGene, getStockDetail, getFdStockDetail} from '@/api'
import config from '@/utils/chart/config'

export default {
  data () {
    return {
      openPanel: false,
      gene: {},
      detail: {},
      peRatio: '--'
    }
  },
  computed: {
    ...mapState(['statistic', 'dyna', 'market', 'code', 'region', 'statics', 'isIndex']),
    // 港美股用 store 订阅得到的 dyna（201/204 快照含 TheEps、Gx、Gxl）
    snapEps () {
      if (this.region === 'CN') return null
      const v = this.dyna.TheEps
      return v !== undefined && v !== null && v !== '' ? v : null
    },
    snapGx () {
      if (this.region === 'CN') return null
      const v = this.dyna.Gx
      return v !== undefined && v !== null && v !== '' ? v : null
    },
    snapGxl () {
      if (this.region === 'CN') return null
      const v = this.dyna.Gxl
      return v !== undefined && v !== null && v !== '' ? v : null
    },
    displayEps () {
      if (this.snapEps === null) return '--'
      const value = this.region === 'USA' ? Number(this.snapEps) / 10 : Number(this.snapEps)
      return value.toFixed(3)
    },
    displayGx () {
      if (this.snapGx === null) return '--'
      return Number(this.snapGx).toFixed(config.region[this.region].precision)
    },
    displayGxl () {
      if (this.snapGxl === null) return '--'
      return Number(this.snapGxl).toFixed(2) + '%'
    },
    weicha () {
      const dyna = this.dyna
      let buySum = dyna.BuyVolume && dyna.BuyVolume.reduce((v1, v2) => v1 + v2)
      let sellSum = dyna.SellVolume && dyna.SellVolume.reduce((v1, v2) => v1 + v2)
      return Math.ceil((buySum - sellSum) / 100)
    },
    getPanelType () {
      if(!this.openPanel || this.isIndex) return ''
      if(this.region === 'CN') return 'panel-full'
      if(this.region === 'HK') return 'panel-full-hk'
      if(this.region === 'USA') return 'panel-full-usa'
    },
    // 成交量（按手换算后）供 formatUnit 使用
    volumeForUnit () {
      const v = this.dyna.Volume
      if (v === undefined || v === null) return null
      return Math.round(Number(v) / config.region[this.region].singleHand)
    }
  },
  filters: {
    getPrice (val, region = 'CN') {
      return val !== undefined && !isNaN(val) && Number(val).toFixed(config.region[region].precision) || '--'
    }
  },
  watch: {
    dyna: {
      handler () {
        this.getPERatio()
      }
    }
  },
  async created () {
    this[`init${this.region}`]()
  },
  methods: {
    initCN () {
      this.getGene()
    },
    initUSA () {
      this.getDetail()
    },
    initHK () {
      this.getDetail()
    },
    async getGene () {
      const {market, code} = this
      const res = await getStockGene({market, code})
      if(Object.prototype.toString.call(res) === '[object Object]') {
        this.gene = res
      }
    },
    async getDetail () {
      const {market, code} = this
      const res = await getStockDetail({market, code})
      if(res.status === 0) {
        this.detail = res.data
        this.getFdStockDetail()
        this.getPERatio()
      }
    },
    async getFdStockDetail () {
      const {market, code} = this
      const {data} = await getFdStockDetail({market: market.toLocaleUpperCase(), code})
      if(data) {
        this.detail.ttmdivshr = data.DivPerShare
        this.detail.ttmepsxclx = data.EPS
        this.detail.NetProfTTM = data.NetProfTTM
        this.detail.TotalShare = data.TotalShare
        this.getPERatio()
      }
    },
    getColor (val, base) {
      base = base === undefined ? this.statistic.PreClosePrice : base
      let f = val - base
      if(f > 0) return 'rise-color'
      if(f < 0) return 'fall-color'
      return 'draw-color'
    },
    getPERatio () {
      if(this.region === 'CN') {
        this.peRatio = this.dyna.PERatio
          ? this.dyna.PERatio > 0
            ? this.dyna.PERatio.toFixed(2)
            : '亏损'
          : '--'
      } else {
        // 港美股用 store 订阅的 dyna.TTM，未到时用 detail 兜底
        const ttm = this.dyna.TTM
        if (ttm !== undefined && ttm !== null && ttm !== '') {
          this.peRatio = Number(ttm) > 0 ? Number(ttm).toFixed(2) : '亏损'
        } else {
          this.peRatio = getPERatio(this.detail.NetProfTTM, this.detail.TotalShare, this.code, this.dyna.LastPrice)
        }
      }
    },
    // 统一使用 @/utils 的 formatUnit，仅做空值兜底并转发参数 (val, base, unitText, precision)
    formatUnit (val, base = null, unitText = true, precision = 2) {
      if (val === undefined || val === null) return '--'
      const result = formatUnitFromUtils(val, base, unitText, precision)
      return result || '--'
    }
  },
}
